import { Typography } from '@sl/react-datafabric-components';
import { classNames } from 'primereact/utils';
import * as React from 'react';
import styles from '../sign-up/sign-up.module.css';

interface AuthPageWrapperProps {
  children: React.ReactNode;
  title?: string;
  subtitle?: string;
}

const videoUrl = 'http://ghostnews.ai/wp-content/uploads/2025/05/output-1.mp4';

export const AuthPageWrapper: React.FC<AuthPageWrapperProps> = ({
  children,
  title,
  subtitle,
}) => {
  return (
    <div
      className={classNames(
        styles.fontFamily,
        'flex min-h-screen bg-white flex-column sm:flex-row'
      )}
    >
      {/* Left: Video and Headline */}
      <div
        className={classNames(
          styles.background1,
          'flex flex-column align-items-center justify-content-center w-full sm:w-7 lg:w-8 p-6 order-2 sm:order-1'
        )}
        style={{ background: '#fcfcfc' }} // video background color
      >
        <video
          src={videoUrl}
          autoPlay
          loop
          muted
          className='w-full'
          style={{ maxWidth: '100%', height: 'auto' }}
        />
        <Typography
          type={1}
          className={classNames(
            styles.color1,
            'text-center font-normal mt-4 sm:mt-8 mb-2 sm:mb-4'
          )}
        >
          {title}
        </Typography>
        <div
          className={classNames(
            styles.color2,
            'mt-2 text-lg sm:text-xl text-center px-2'
          )}
        >
          {subtitle}
        </div>
      </div>

      {/* Right: Form */}
      <div
        className={classNames(
          styles.background1,
          'flex align-items-center justify-content-center w-full flex-1 sm:w-4 p-3 sm:p-6 order-1 sm:order-2'
        )}
      >
        <div className='w-full' style={{ maxWidth: '100%', padding: '0 1rem' }}>
          {children}
        </div>
      </div>
    </div>
  );
};

export default AuthPageWrapper;
